<script lang="ts" setup>
import type { PlpPage } from '@integration-layer/ampliance/schemas/plp-page-schema.localized'
import type { PlpPageProps } from '../Templates/TemplatesPlp.props'
import type { AlgoliaVisualFiltersProps } from '../Algolia/AlgoliaVisualFilters.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: PlpPage
}>()

const data = await useComponentResponse<PlpPage>(props)

const seo = data.value?.seo
const seoExtraData: PlpMeta = {
  type: 'plp',
  title: data.value?.categoryTitle ?? '',
}

// @ts-ignore
const transformedData = computed<PlpPageProps>(() => ({
  brand: data.value!.brand,
  urlSlug: data.value!.urlSlug!,
  seoText: data.value!.seoText!,
  categoryId: data.value!.categoryId!,
  parentPage: data.value!.parentPage,
  bannerImage: data.value!.bannerImage,
  lvlCategory: data.value!.lvlCategory!,
  subcategory: data.value?.subcategory ?? false,
  logicWrapper: data.value?.logicWrapper,
  crossNavigation: data.value?.crossNavigation,
  categoryTitle: data.value!.categoryTitle!,
  categorySubTitle: data.value!.categorySubTitle!,
  visualFilter: data.value!
    .visualFilter as unknown as AlgoliaVisualFiltersProps,
  xGenFirstRowComponent: data.value?.xGenRow ?? false,
}))
if (seo)
  await useAmplienceSeo({
    // @ts-ignore
    deliveryId: seo._meta.deliveryId,
    content: seo,
    extraData: seoExtraData,
  })
</script>

<template>
  <div>
    <TemplatesPlp v-bind="transformedData as unknown as PlpPageProps" />
    <MoleculesBackToTop />
  </div>
</template>
